import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuCM from "components/shared/menu";
import ProfileMenuCM from "components/profilemenu";
import FooterCM from "components/shared/footer";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import {
  StyledCardContent,
  StyledTypography,
  StyledTypographyAdmin,
  StyledChoiceFileText,
  StyledUploadBox,
  StyledContainerBox,
  StyledTypographyUser,
} from "./Ticket.style";
import { getTicketbyIdRequest, EditTicketRequest } from "api/requests";
import useHttp from "hooks/use-http";
import LoadingCM from "components/shared/Loading";
import BackButton from "components/shared/BackButton";
import ContactCM from "components/contactus";
import TextField from "@mui/material/TextField";
import { Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { EditTicketSchema } from "validations";
import Toast from "helper/toast";
import CheckIcon from "@mui/icons-material/Check";
import FormHelperText from "@mui/material/FormHelperText";
import { IMG_BASE_URL } from "constants";
import { ImUpload } from "react-icons/im";
import { IoMdDownload } from "react-icons/io";
import {Helmet} from "react-helmet";

////////////////////////////
const formList = [
  {
    label: "شرح تیکت",
    type: "text",
    id: "text",
  },
];

export default function Message() {
  const params = useParams();
  const { request, loading } = useHttp();
  const [message, setMessage] = useState([]);
  const [ticketmessage, setticketMessage] = useState([]);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(EditTicketSchema),
  });
  const [file, setFile] = useState("");

  const onSubmit = async (data) => {
    const res = await request({
      url: EditTicketRequest,
      values: { ...data, ticket_id: params.messageId },
    });
    if (res) {
      reset({
        text: "",
        file: "",
      });
      getTicket();
      setFile("");
      Toast({ type: "success", title: "ارسال پیام" });
    }
  };

  const getTicket = useCallback(async () => {
    let res = await request({
      url: getTicketbyIdRequest,
      values: params.messageId,
    });
    setMessage(res);
    setticketMessage(res.ticket_messages);
  }, [request, params.messageId]);

  useEffect(() => {
    getTicket();
  }, [getTicket]);

  return (
    <>
      {loading && <LoadingCM />}
      <Helmet>
        <title>پشتیبانی - مبلمان ویول</title>
        <meta name="product_id" content={""} />
        <meta name="product_name" content={""} />
        <meta name="product_price" content={""} />
        <meta name="product_old_price" content={""} />
        <meta name="availability" content={""} />
        <meta property="og:image" content={""} />
      </Helmet>
      <MenuCM Background pageTitle="پشتیبانی" />
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={3} lg={3}>
            <ProfileMenuCM />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} mb={10}>
            <Paper p={2}>
              <StyledCardContent>
                <Typography
                  variant="body2"
                  sx={{
                    fontSize: "21px",
                  }}
                >
                  تیکت های من
                </Typography>
              </StyledCardContent>
              <Grid
                container
                style={{ paddingRight: "20px", direction: "rtl" }}
              >
                <Grid item mt={3} mb={3} xs={12}>
                  <BackButton />
                </Grid>
              </Grid>
              <div>
                <StyledTypography variant="body2">
                  <div>
                    <span>موضوع : </span>
                    {message.title}
                  </div>
                  <div style={{ marginTop: "10px" }}>
                    <span>وضعیت : </span>
                    {message?.status == "open" ? "باز" : "بسته شده"}
                  </div>
                </StyledTypography>
              </div>

              {ticketmessage?.map((items, index) => (
                <div key={index}>
                  {items?.sender_type == "admin" ? (
                    <div style={{ direction: "ltr" }}>
                      <StyledTypographyAdmin variant="body2">
                        <div>{items?.text}</div>
                        <div style={{ marginTop: "10px" }} className="file">
                          {items?.file == null ? (
                            ""
                          ) : (
                            <>
                              <a
                                href={IMG_BASE_URL + items.file}
                                target="_blank"
                              >
                                <IoMdDownload />
                              </a>
                              <span style={{ marginLeft: "10px" }}>
                                <span> فایل ضمیمه </span>
                                <span
                                  style={{ fontSize: "12px", color: "#595959" }}
                                >
                                  {" "}
                                  {items?.file_size}
                                </span>
                              </span>
                            </>
                          )}
                        </div>
                        <div style={{ marginTop: "10px" }} className="date">
                          {items?.created_at?.jdate}
                        </div>
                        <span className="arrow"></span>
                      </StyledTypographyAdmin>
                    </div>
                  ) : (
                    <StyledTypographyUser variant="body2">
                      <div>{items?.text}</div>
                      <div style={{ marginTop: "10px" }} className="file">
                        {items?.file == null ? (
                          ""
                        ) : (
                          <>
                            <a href={IMG_BASE_URL + items.file} target="_blank">
                              <IoMdDownload />
                            </a>
                            <span style={{ marginRight: "10px" }}>
                              <span> فایل ضمیمه </span>
                              <span
                                style={{
                                  fontSize: "12px",
                                  color: "white",
                                  direction: "ltr",
                                  textAlign: "right",
                                }}
                              >
                                {" "}
                                {items?.file_size}
                              </span>
                            </span>
                          </>
                        )}
                      </div>
                      <div style={{ marginTop: "10px" }} className="date">
                        {items?.created_at?.jdate}
                      </div>
                      <span className="arrow"></span>
                    </StyledTypographyUser>
                  )}
                </div>
              ))}
              {message?.status == "open" ? (
                <Grid item xs={12} sm={12} md={12} lg={12} mb={2}>
                  <Paper p={2} elevation={0}>
                    <StyledCardContent>
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "21px",
                        }}
                      >
                        پیام جدید
                      </Typography>
                    </StyledCardContent>
                    <CardContent>
                      <Grid container spacing={1}>
                        {formList.map((items, index) => (
                          <Grid
                            item
                            md={12}
                            xs={12}
                            // p={1.5}
                            key={"profile" + index}
                          >
                            <TextField
                              id={items.id}
                              label={items.label}
                              variant="outlined"
                              required={items.required}
                              fullWidth
                              {...register(items.id)}
                              readOnly={items.readOnly}
                              error={Boolean(errors[items.id])}
                              multiline={items.id == "text" ? true : false}
                              rows={items.id == "text" ? 4 : 1}
                            />
                            <FormHelperText id={items.id}>
                              {errors[items.id]?.message}
                            </FormHelperText>
                          </Grid>
                        ))}
                        <Grid item md={12} xs={12}>
                          <Grid item md={12} xs={12}>
                            <StyledContainerBox>
                              <StyledUploadBox>
                                <StyledChoiceFileText>
                                  {file ? file : "آپلود فایل ضمیمه"}
                                </StyledChoiceFileText>
                                <ImUpload />
                              </StyledUploadBox>
                              <TextField
                                type="file"
                                variant="outlined"
                                fullWidth
                                id={file}
                                {...register("file")}
                                error={Boolean(errors.file)}
                                helpertext={errors.file?.message}
                                onChange={(e) =>
                                  setFile(e.target.files[0].name)
                                }
                              />
                            </StyledContainerBox>
                          </Grid>
                        </Grid>
                        <Grid
                          item
                          md={12}
                          xs={12}
                          style={{ direction: "ltr", paddingTop: "0px" }}
                        >
                          <Button
                            color="success"
                            startIcon={<CheckIcon />}
                            variant="contained"
                            sx={{ mt: 2 }}
                            onClick={handleSubmit(onSubmit)}
                            style={{ direction: "rtl" }}
                          >
                            ارسال پیام
                          </Button>
                        </Grid>
                      </Grid>
                    </CardContent>
                  </Paper>
                </Grid>
              ) : (
                ""
              )}
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ContactCM All />
      <FooterCM />
    </>
  );
}
